import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardActionToggle } from '@/common/components/CardActionToggle/CardActionToggle';
import { Icon } from '@/common/components/Icons/Icon';
import { Translate } from '@/common/components/Translate/Translate';
import { useNotificationsContext } from '@/common/contexts/notifications/NotificationsContext';
import { NotificationsService } from '@/common/integrations/notifications/notifications-service';
import { StorageService } from '@/common/integrations/storage/storage.service';
import { notify } from '@/common/utils/toast/toast';

const NotificationsToggle: FunctionComponent = (props) => {
  const { t } = useTranslation();
  const { setNotificationToken } = useNotificationsContext();

  const [toggleActive, setToggleActive] = useState(false);

  useEffect(() => {
    const getNotificationToken = async () => {
      const token = await StorageService.getNotificationToken();
      setToggleActive(token !== null);
    };
    getNotificationToken();
  }, []);

  const notifyError = () => {
    notify({
      type: 'error',
      message: (
        <Translate
          i18nKey={
            'authentication.notifications.errors.notifications_activation_failed'
          }
        />
      ),
    });
  };

  const onActivateNotifications = async () => {
    if (toggleActive) {
      await NotificationsService.unregisterForPushNotificationsAsync();
      setToggleActive(false);
      return;
    }
    try {
      const token =
        await NotificationsService.registerForPushNotificationsAsync();
      if (token) {
        setNotificationToken(token);
        setToggleActive(true);
        return;
      }
      notifyError();
    } catch (err: any) {
      notifyError();
    }
  };

  return (
    <CardActionToggle
      icon={<Icon icon="bell" />}
      title={t('dashboard.profile.sections.settings.push_notifications.title')}
      onChange={onActivateNotifications}
      checked={toggleActive}
      {...props}
    />
  );
};

export default NotificationsToggle;
